"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

var _index = require("@insided/destination/modules/Content/ProductAreaFilter/index.sync");

var _productAreas = require("@insided/shared/utils/productAreas");

var _zod = require("zod");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// eslint-disable-next-line import/no-internal-modules
var widgetName = 'product_area_filter';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-product_area_filter';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  productAreaFilterList: _zod.z.array(_zod.z.string()).nullable(),
  productAreas: _zod.z.array(_zod.z.object({
    id: _zod.z.number(),
    name: _zod.z.string(),
    isSection: _zod.z.boolean(),
    displayOrder: _zod.z.number().optional(),
    parentId: _zod.z.number().nullable(),
    children: _zod.z.array(_zod.z.any())
  })),
  selectedProductArea: _zod.z.string().nullable(),
  selectedProductAreaSectionId: _zod.z.string().nullable(),
  selectedProductAreaFilterOption: _zod.z.number(),
  config: _zod.z.any()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var WidgetProductAreaFilter = function WidgetProductAreaFilter(props) {
  var productAreaFilterList = props.productAreaFilterList,
      selectedProductAreaFilterOption = props.selectedProductAreaFilterOption,
      selectedProductArea = props.selectedProductArea,
      productAreas = props.productAreas,
      selectedProductAreaSectionId = props.selectedProductAreaSectionId;
  var numericProductAreaFilterList = productAreaFilterList === null || productAreaFilterList === void 0 ? void 0 : productAreaFilterList.map(function (item) {
    return Number(item);
  });
  var configuredProductAreaList = (0, _productAreas.filterProductAreasById)(productAreas, numericProductAreaFilterList, selectedProductAreaFilterOption);
  return (0, _preact.h)(_widgetContainer.default, {
    widgetName: "product_area_filter",
    config: {},
    boundedContext: "Content",
    entity: "ProductAreaFilter"
  }, (0, _preact.h)(_index.ProductAreaFilter, {
    productAreas: configuredProductAreaList,
    selectedProductArea: selectedProductArea,
    selectedProductAreaSectionId: selectedProductAreaSectionId
  }));
};

var _default = WidgetProductAreaFilter;
exports.default = _default;